import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import './BookingDetails.css';

const BookingDetails = () => {
  const navigate = useNavigate();
  const { bookingId } = useParams();

  // Placeholder booking data
  const bookingData = {
    id: bookingId || 'SF12345678',
    bookingStatus: 'Confirmed',
    paymentStatus: 'Paid',
    bookingDate: '2024-12-10',
    totalAmount: '₦850,000',
    
    passenger: {
      fullName: 'John Doe',
      email: 'john.doe@example.com',
      phone: '+234 801 234 5678',
      nationality: 'Nigeria',
      idNumber: 'A12345678'
    },
    
    flight: {
      airline: 'British Airways',
      flightNumber: 'SF101',
      route: 'Lagos → London',
      departureDate: '2024-12-15',
      departureTime: '14:20',
      arrivalDate: '2024-12-16',
      arrivalTime: '06:30',
      cabinClass: 'Business',
      seatNumber: '12A'
    },
    
    payment: {
      method: 'Paystack',
      transactionId: 'TXN001234',
      amountPaid: '₦850,000',
      paymentDate: '2024-12-10',
      paymentStatus: 'Paid'
    },
    
    timeline: [
      { event: 'Booking created', timestamp: '2024-12-10 10:30', status: 'completed' },
      { event: 'Payment completed', timestamp: '2024-12-10 10:32', status: 'completed' },
      { event: 'Ticket issued', timestamp: '2024-12-10 10:35', status: 'completed' },
      { event: 'Seat assigned', timestamp: '2024-12-11 14:20', status: 'completed' }
    ]
  };

  const handleCancelBooking = () => {
    // Placeholder
    console.log('Cancel booking:', bookingData.id);
  };

  const handleRescheduleBooking = () => {
    // Placeholder
    console.log('Reschedule booking:', bookingData.id);
  };

  const handleDownloadTicket = () => {
    // Placeholder
    console.log('Download ticket for booking:', bookingData.id);
  };

  const handleDownloadInvoice = () => {
    // Placeholder
    console.log('Download invoice for booking:', bookingData.id);
  };

  const getTimelineIcon = (status) => {
    return status === 'completed' ? '✓' : '○';
  };

  return (
    <AdminLayout pageTitle="Booking Details">
      <div className="admin-booking-details-page">
        {/* Page Title */}
        <div className="admin-booking-details-header">
          <h1 className="admin-booking-details-title">Booking Details</h1>
          <nav className="admin-breadcrumb">
            <button 
              className="admin-breadcrumb-link"
              onClick={() => navigate('/admin/bookings')}
            >
              Bookings
            </button>
            <span className="admin-breadcrumb-separator">→</span>
            <span className="admin-breadcrumb-current">Booking Details</span>
          </nav>
        </div>

        {/* Booking Summary Card */}
        <div className="admin-booking-summary-card">
          <div className="admin-booking-summary-content">
            <div className="admin-booking-summary-info">
              <div className="admin-booking-summary-row">
                <div className="admin-booking-summary-item">
                  <label className="admin-booking-summary-label">Booking ID</label>
                  <div className="admin-booking-summary-value admin-booking-id">{bookingData.id}</div>
                </div>
                <div className="admin-booking-summary-item">
                  <label className="admin-booking-summary-label">Booking Status</label>
                  <div className="admin-booking-summary-value">
                    <span className={`admin-status-badge admin-status-${bookingData.bookingStatus.toLowerCase()}`}>
                      {bookingData.bookingStatus}
                    </span>
                  </div>
                </div>
              </div>
              <div className="admin-booking-summary-row">
                <div className="admin-booking-summary-item">
                  <label className="admin-booking-summary-label">Payment Status</label>
                  <div className="admin-booking-summary-value">
                    <span className={`admin-status-badge admin-status-${bookingData.paymentStatus.toLowerCase()}`}>
                      {bookingData.paymentStatus}
                    </span>
                  </div>
                </div>
                <div className="admin-booking-summary-item">
                  <label className="admin-booking-summary-label">Booking Date</label>
                  <div className="admin-booking-summary-value">{bookingData.bookingDate}</div>
                </div>
              </div>
              <div className="admin-booking-summary-row">
                <div className="admin-booking-summary-item">
                  <label className="admin-booking-summary-label">Total Amount</label>
                  <div className="admin-booking-summary-value admin-booking-amount">{bookingData.totalAmount}</div>
                </div>
              </div>
            </div>
            <div className="admin-booking-summary-actions">
              <button
                className="admin-summary-action-button"
                onClick={handleCancelBooking}
              >
                Cancel Booking
              </button>
              <button
                className="admin-summary-action-button"
                onClick={handleRescheduleBooking}
              >
                Reschedule Booking
              </button>
            </div>
          </div>
        </div>

        {/* Content Grid */}
        <div className="admin-booking-details-grid">
          {/* Passenger Information */}
          <div className="admin-details-card">
            <div className="admin-details-card-header">
              <h2 className="admin-details-card-title">Passenger Details</h2>
            </div>
            <div className="admin-details-card-content">
              <div className="admin-details-field">
                <label className="admin-details-label">Full Name</label>
                <div className="admin-details-value">{bookingData.passenger.fullName}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Email</label>
                <div className="admin-details-value">{bookingData.passenger.email}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Phone</label>
                <div className="admin-details-value">{bookingData.passenger.phone}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Nationality</label>
                <div className="admin-details-value">{bookingData.passenger.nationality}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">ID / Passport Number</label>
                <div className="admin-details-value">{bookingData.passenger.idNumber}</div>
              </div>
            </div>
          </div>

          {/* Flight Information */}
          <div className="admin-details-card">
            <div className="admin-details-card-header">
              <h2 className="admin-details-card-title">Flight Details</h2>
            </div>
            <div className="admin-details-card-content">
              <div className="admin-details-field">
                <label className="admin-details-label">Airline</label>
                <div className="admin-details-value">{bookingData.flight.airline}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Flight Number</label>
                <div className="admin-details-value">{bookingData.flight.flightNumber}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Route</label>
                <div className="admin-details-value">{bookingData.flight.route}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Departure</label>
                <div className="admin-details-value">
                  {bookingData.flight.departureDate} at {bookingData.flight.departureTime}
                </div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Arrival</label>
                <div className="admin-details-value">
                  {bookingData.flight.arrivalDate} at {bookingData.flight.arrivalTime}
                </div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Cabin Class</label>
                <div className="admin-details-value">{bookingData.flight.cabinClass}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Seat Number</label>
                <div className="admin-details-value">{bookingData.flight.seatNumber}</div>
              </div>
            </div>
          </div>

          {/* Payment Information */}
          <div className="admin-details-card">
            <div className="admin-details-card-header">
              <h2 className="admin-details-card-title">Payment Details</h2>
            </div>
            <div className="admin-details-card-content">
              <div className="admin-details-field">
                <label className="admin-details-label">Payment Method</label>
                <div className="admin-details-value">{bookingData.payment.method}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Transaction ID</label>
                <div className="admin-details-value admin-transaction-id">{bookingData.payment.transactionId}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Amount Paid</label>
                <div className="admin-details-value admin-payment-amount">{bookingData.payment.amountPaid}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Payment Date</label>
                <div className="admin-details-value">{bookingData.payment.paymentDate}</div>
              </div>
              <div className="admin-details-field">
                <label className="admin-details-label">Payment Status</label>
                <div className="admin-details-value">
                  <span className={`admin-status-badge admin-status-${bookingData.payment.paymentStatus.toLowerCase()}`}>
                    {bookingData.payment.paymentStatus}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Booking Timeline */}
          <div className="admin-details-card">
            <div className="admin-details-card-header">
              <h2 className="admin-details-card-title">Booking Activity</h2>
            </div>
            <div className="admin-details-card-content">
              <div className="admin-timeline">
                {bookingData.timeline.map((item, index) => (
                  <div key={index} className="admin-timeline-item">
                    <div className="admin-timeline-icon">{getTimelineIcon(item.status)}</div>
                    <div className="admin-timeline-content">
                      <div className="admin-timeline-event">{item.event}</div>
                      <div className="admin-timeline-timestamp">{item.timestamp}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Download Section */}
        <div className="admin-download-section">
          <div className="admin-download-card">
            <div className="admin-download-header">
              <h2 className="admin-download-title">Downloads</h2>
            </div>
            <div className="admin-download-content">
              <button
                className="admin-download-button"
                onClick={handleDownloadTicket}
              >
                📄 Download Ticket
              </button>
              <button
                className="admin-download-button"
                onClick={handleDownloadInvoice}
              >
                📄 Download Invoice
              </button>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default BookingDetails;

